module.exports = {
  black: "#333",
  blue: "#0f4890",
  green: "#20603c",
  purple: "#8b008b",
  silver: "#eee",
  white: "#fafafa",
}
